import React from 'react';
import SiteHeader from '../../components/siteChrome/SiteHeader';
import SiteFooter from '../../components/siteChrome/SiteFooter';
import BookingSplit from './sections/BookingSplit';
import ComparisonTeaser from './sections/ComparisonTeaser';
import EngagementSplit from './sections/EngagementSplit';
import WebsiteSplit from './sections/WebsiteSplit';
import FeaturesGrid from './sections/FeaturesGrid';
import FinalCta from './sections/FinalCta';
import Hero from './sections/Hero';
import MembershipSplit from './sections/MembershipSplit';
import SeoProse from './sections/SeoProse';
import StatsBand from './sections/StatsBand';
import TrustStrip from './sections/TrustStrip';
import './home.css';

const Home = (): React.JSX.Element => {
  return (
    <>
      <SiteHeader />
      <main id="main-content" role="main" tabIndex={-1}>
        <Hero />
        <TrustStrip />
        <FeaturesGrid />
        <BookingSplit />
        <MembershipSplit />
        <EngagementSplit />
        <WebsiteSplit />
        <ComparisonTeaser />
        <SeoProse />
        <StatsBand />
        <FinalCta />
      </main>
      <SiteFooter />
    </>
  );
};

export default Home;
